/**
 * スタッフ email → 氏名の解決フック。
 *
 * AI エージェント定義や帳票フォーマットの共有メンバー (shared_with は email 配列) を
 * 画面上で氏名表示するために使う。MasterDataProvider が起動時に取得済みのスタッフ一覧
 * (staff_id=email, staff_name=氏名) を引くだけなので追加の API 呼び出しは無い。
 * 一覧に無い email (退職者等) はそのまま email を返す。
 */
import { useCallback, useMemo } from 'react';
import { useMasterData } from '../providers/MasterDataProvider';

export function useStaffNames() {
  const { staffList } = useMasterData();

  const nameByEmail = useMemo(() => {
    const map = new Map<string, string>();
    for (const s of staffList as { staff_id?: string; staff_name?: string }[]) {
      const email = (s.staff_id ?? '').trim().toLowerCase();
      const name = (s.staff_name ?? '').trim();
      if (email && name) map.set(email, name);
    }
    return map;
  }, [staffList]);

  /** email を氏名へ変換する (未登録なら email のまま) */
  const resolve = useCallback(
    (email: string): string => nameByEmail.get(email.trim().toLowerCase()) ?? email,
    [nameByEmail],
  );

  /** email 配列を「氏名、氏名、…」の表示文字列にする */
  const formatMembers = useCallback(
    (emails: string[] | undefined): string => (emails ?? []).map(resolve).join('、'),
    [resolve],
  );

  return { resolve, formatMembers };
}
